import React, {useState} from 'react';
import AurServiceAgreementDropdown, {
  ServiceAgreementProps,
} from '../../project-creation/components/AurServiceAgreementDropdown';
import {Link} from 'react-router-dom';

const yourAgreementList: ServiceAgreementProps[] = [
  {
    geography: 'US',
    countryName: 'United States',
    engagementName: 'AMSBE Short Name Lorem Ipsum Dolor',
    id: '123456',
    engagementCode: '123456 - 123456',
    serviceType: 'Self Service',
    engagementType: 'Subscription',
  },
  {
    geography: 'US',
    countryName: 'United States',
    engagementName:
      'AMSBE Long Name 83 characters Maximum Lorem Ipsum Dolor Amet Consectetur Aperiam',
    id: '789012',
    engagementCode: '123456 - 123456',
    serviceType: 'Self Service',
    engagementType: 'Subscription',
  },
  {
    geography: 'FR',
    countryName: 'France',
    engagementName: 'AMSBE Short Name Lorem Ipsum Dolor Amet',
    id: '234567',
    engagementCode: '123456 - 123456',
    serviceType: 'Self Service',
    engagementType: 'Subscription',
  },
  {
    geography: 'GB',
    countryName: 'United Kingdom',
    engagementName: 'AMSBE Short Name',
    id: '345678',
    engagementCode: '123456 - 123456',
    serviceType: 'Self Service',
    engagementType: 'Subscription',
  },
];

const ServiceAgreementSelect: React.FC = () => {
  /// this is a sample component view for Demo page
  const [selectedId, setSelectedId] = useState<string>('');
  return (
    <div style={{marginBottom: '64px', width: '50%'}}>
      <h1>AurServiceAgreementDropdown demo</h1>
      <Link to="/demo">Return</Link>
      <br />
      <div style={{marginBottom: '32px'}}>
        <AurServiceAgreementDropdown
          options={yourAgreementList}
          value={selectedId}
          onChange={setSelectedId}
        />
      </div>
    </div>
  );
};

export default ServiceAgreementSelect;
